import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from './button-icon';

const IgnitePagination = ({
	action,
	currentPage,
	totalPages,
}) => {
	const [hellipStart, setHellipStart] = useState(false);
	const [hellipEnd, setHellipEnd] = useState(false);
	const [pageList, setPageList] = useState(null);

	const updatePagination = () => {
		let newHellipStart = false;
		let newHellipEnd = false;

		let newPageList = Array.from(Array(totalPages), (_, x) => x + 1);

		newPageList.shift();
		newPageList.pop();

		if (totalPages > 6) {
			if (currentPage <= 3) {
				newPageList = newPageList.slice(0, 4);
				newPageList.unshift(1);
				newPageList.push(totalPages);

				newHellipEnd = true;
			} else if (currentPage > 3 && currentPage <= totalPages - 4) {
				newPageList = newPageList.slice(currentPage - 3, currentPage + 1);
				newPageList.unshift(1);
				newPageList.push(totalPages);

				newHellipStart = true;
				newHellipEnd = true;
			} else {
				newPageList = newPageList.slice(totalPages - 6, totalPages - 1);
				newPageList.unshift(1);
				newPageList.push(totalPages);

				newHellipStart = true;
			}
		} else {
			if (totalPages !== 1) {
				newPageList.unshift(1);
			}

			newPageList.push(totalPages);
		}

		setHellipStart(newHellipStart);
		setHellipEnd(newHellipEnd);
		setPageList(newPageList);
	};

	const nextPage = () => {
		let page = currentPage;

		if (page < totalPages) {
			page += 1;
		} else {
			return;
		}

		action(page);
	};

	const prevPage = () => {
		let page = currentPage;

		if (page > 1) {
			page -= 1;
		} else {
			return;
		}

		action(page);
	};

	useEffect(() => {
		updatePagination();
	}, [totalPages, currentPage]);

	useEffect(() => {
		updatePagination();
	}, []);

	return (
		<div className="pagination">
			<ButtonIcon
				icon="chevron-left"
				title="Previous"
				classes=""
				onClick={() => prevPage()}
				isDisabled={currentPage === 1 || totalPages === 1}
			/>
			{totalPages > 1 ? (
				<>
					{pageList
						? pageList.map(i => (
							<button
								key={i}
								type="button"
								className={`pagination-button
									${currentPage === i ? ' is-active' : ''}
									${hellipEnd && i === totalPages ? ' is-end' : ''}
									${hellipStart && i === 1 ? ' is-start' : ''}
								`}
								onClick={() => action(i)}
							>
								{i}
							</button>
						))
						: null}
				</>
			) : (
				<button
					type="button"
					className="pagination-button"
					disabled
				>
					1
				</button>
			)}
			<ButtonIcon
				icon="chevron-right"
				title="Next"
				classes=""
				onClick={() => nextPage()}
				isDisabled={currentPage === totalPages || totalPages === 1}
			/>
		</div>
	);
};

export default IgnitePagination;

IgnitePagination.propTypes = {
	currentPage: PropTypes.number.isRequired,
	totalPages: PropTypes.number.isRequired,
	action: PropTypes.func.isRequired,
};
